import { MenuItemProps } from '@lsy-netline/netline-ui/MenuItem';
import clsx from 'clsx';
import { MouseEvent, forwardRef, useCallback } from 'react';

import { OpenInNewIcon, SubjectIcon } from 'icons';
import { MenuItem, styled } from 'netline-ui';
import { HelpTopicWithKey } from 'types';

import styles, { helpMenuItemClasses } from './HelpMenuItem.styles';

export enum HelpIconType {
  Popup = 'Popup',
  Subject = 'Subject',
}

type HelpMenuItemProps = Omit<MenuItemProps, 'onClick'> & {
  topic: HelpTopicWithKey;
  iconType?: HelpIconType;
  onClick: (topic: HelpTopicWithKey, event: MouseEvent<HTMLLIElement>) => void;
};

const HelpMenuItemRoot = styled(MenuItem, { name: helpMenuItemClasses.$name })(styles);

const HelpMenuItem = forwardRef<HTMLLIElement | null, HelpMenuItemProps>(
  ({ className, topic, iconType, onClick, ...props }, ref) => {
    const handleClick = useCallback(
      (event: MouseEvent<HTMLLIElement>) => {
        onClick(topic, event);
      },
      [topic, onClick],
    );

    return (
      <HelpMenuItemRoot
        ref={ref}
        className={clsx(className, helpMenuItemClasses.root)}
        onClick={handleClick}
        dense
        data-testid="HelpMenuItem-root"
        {...props}
      >
        {iconType === HelpIconType.Subject && (
          <SubjectIcon
            className={helpMenuItemClasses.icon}
            fontSize="small"
            color="primary"
            data-testid="HelpMenuItem-subjectIcon"
          />
        )}
        {topic.title}
        {iconType === HelpIconType.Popup && (
          <OpenInNewIcon
            className={helpMenuItemClasses.icon}
            fontSize="small"
            color="primary"
            data-testid="HelpMenuItem-popupIcon"
          />
        )}
      </HelpMenuItemRoot>
    );
  },
);

export default HelpMenuItem;
